import React from 'react';
import { Pie } from '@ant-design/charts';
import { IComponentProperty, ComponentPropertyType } from '../ComponentProperty';
import { v4 as uuidv4 } from 'uuid';
import { Link } from 'react-router-dom';
import useDataSource from '../DataSource';

export const Props: Array<IComponentProperty> = [
    { "name": "id", "type": ComponentPropertyType.String, "required": true, "description": "The ID for this chart", displayName: "Id" },
    { "name": "dataSource", "type": ComponentPropertyType.DataSource, "required": true, "description": <>The <Link to="/admin/automation/scripts" target="_blank">script</Link> or <Link to="/admin/apis/endpoints" target="_blank">API</Link> data source for this chart.</>, displayName: "Data Source", category: "Data Source" },
    { "name": "angleField", "type": ComponentPropertyType.String, "required": true, "description": "The field containing the angle field.", displayName: "Angle Field" },
    { "name": "colorField", "type": ComponentPropertyType.String, "required": true, "description": "The field containing the color field.", displayName: "Color Field" },
]

export const Constructor = () => {
    return {
        "$type": 'PowerShellUniversal.Components.PieChart, PowerShellUniversal',
        "type": "Pie",
        "id": uuidv4(),
    }
}

export function Component(props) {
    const { data, isLoading } = useDataSource(props);

    if (isLoading || !props.angleField || !props.colorField || !data || data.length === 0) {
        return <div />
    }

    return <Pie color={props.color} loading={isLoading} data={data} angleField={props.angleField} colorField={props.colorField} />
}